import { gql } from "@apollo/client";

export const addCompanyPolicySchedule = gql`
  mutation addCompanyPolicySchedule($record: CreateOneCompanyPolicyScheduleInput!) {
    companyPolicySchedule_CreateOne(record: $record) {
      record {
        _id
      }
    }
  }
`;